export const routes = [
  {
    name: "CBK Interest Rates",
    route_name: "interest-rates",
    description: "Central Bank of Kenya Interest Rates",
  },
  {
    name: "Inter-Bank Rates",
    route_name: "interbank-rates",
    description: "Inter-Bank Daily Rates",
  },
  {
    name: "Forex Rates",
    route_name: "forex-rates",
    description: "Forex Rates",
  },
  //   {
  //     name: "Treasury Bonds",
  //     route_name: "treasury-bonds",
  //     description: "All Treasury Bonds info from Central Bank of Kenya",
  //   },
  //   {
  //     name: "Treasury Bills",
  //     route_name: "treasury-bills",
  //     description: "All Treasury Bills info from Central Bank of Kenya",
  //   },
];
